import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NgOptimizedImage } from '@angular/common';
import { RouterResolveStatusService } from '@shared/services/router-resolve-status.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatProgressBar } from '@angular/material/progress-bar';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-external-template',
  templateUrl: './external-template.component.html',
  styleUrl: './external-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbar, NgOptimizedImage, MatProgressBar, RouterOutlet],
})
export class ExternalTemplateComponent {
  routerResolveStatus = inject(RouterResolveStatusService);
}
